import _regeneratorRuntime from "/root/code/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from "axios";
import { encodeSearchTerm } from "../utilities/url";
export var searchRedirectUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios.get("/search/redirect-url?query=".concat(encodeSearchTerm(query)));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res.data.redirectUrl);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function searchRedirectUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();